"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAnswers = formatAnswers;
const fieldTypes_1 = require("../types/carrierQuestionnaire/fieldTypes");
const ExpandedContextVisitor_1 = require("./expandedContext/ExpandedContextVisitor");
const parseNumericValue_1 = require("../condition-engine/helpers/parseNumericValue");
class FormatAnswersVisitor extends ExpandedContextVisitor_1.ExpandedContextVisitor {
    static NUMERIC_FIELD_TYPES = [fieldTypes_1.FieldTypes.number, fieldTypes_1.FieldTypes.money];
    answersResolver;
    constructor(answersResolver) {
        super(ExpandedContextVisitor_1.RepetitionIntervalBoundary.maxRepetitions);
        this.answersResolver = answersResolver;
    }
    numberOfRepetitions(repeatableNode) {
        return (this.answersResolver.getRepetitionCount(repeatableNode.blueprintId, this.repeatedInstanceIdentifiers().byBlueprintId) ?? 0);
    }
    visitField(field) {
        if (FormatAnswersVisitor.NUMERIC_FIELD_TYPES.includes(field.type)) {
            const repeatedInstanceIdentifiers = this.repeatedInstanceIdentifiers();
            const answer = this.answersResolver.getAnswer(field.blueprintId, repeatedInstanceIdentifiers.byBlueprintId);
            if (typeof answer !== 'string') {
                return;
            }
            const numberAnswer = (0, parseNumericValue_1.parseNumericValue)(answer);
            if (isNaN(numberAnswer)) {
                // Unset NaN answers so we never save NaN when a numeric field answer is an empty or invalid string
                // Also required as part of workaround of issue with Yup rejecting optional number inputs when left empty
                const nodeInstancesToRemove = [{ id: field.blueprintId, scope: repeatedInstanceIdentifiers.byBlueprintId }];
                this.answersResolver.unsetAnswers(nodeInstancesToRemove);
            }
            else {
                // Replace the string answer by a number
                this.answersResolver.setAnswer(numberAnswer, field.blueprintId, repeatedInstanceIdentifiers.byBlueprintId);
            }
        }
    }
}
function formatAnswers(questionnaire, answersResolver) {
    const visitor = new FormatAnswersVisitor(answersResolver);
    visitor.visitQuestionnaire(questionnaire);
}
